/** Id constants for elements throughout the codebase */ export var ElementIds = /*#__PURE__*/ function(ElementIds) {
    /** Left nav element ids */ ElementIds["MyDayNavButton"] = "myDayNavButton";
    ElementIds["MyTasksNavButton"] = "myTasksNavButton";
    ElementIds["MyPlansNavButton"] = "myPlansNavButton";
    ElementIds["MyPortfoliosNavButton"] = "myPortfoliosNavButton";
    ElementIds["LeftNavNewPlanButton"] = "leftNavNewPlanButton";
    /** My Day element ids */ ElementIds["MyDayTaskSuggestionsButton"] = "myDayTaskSuggestionsButton";
    /** My Tasks element ids */ ElementIds["MyTasksAllPivot"] = "myTasksAllPivot";
    ElementIds["MyTasksPrivatePivot"] = "myTasksPrivatePivot";
    ElementIds["MyTasksAssignedToMePivot"] = "myTasksAssignedToMePivot";
    ElementIds["MyTasksFlaggedEmailsPivot"] = "myTasksFlaggedPivot";
    ElementIds["MyTasksImportantPivot"] = "myTasksImportantPivot";
    ElementIds["MyTasksDueSoonPivot"] = "myTasksDueSoonPivot";
    ElementIds["MyTasksNewExperienceToggle"] = "myTasksNewExperienceToggle";
    ElementIds["MyTasksFirstGroupHeader"] = "myTasksFirstGroupHeader";
    ElementIds["MyTasksFirstTaskRow"] = "myTasksFirstTaskRow";
    /** My Plans element ids */ ElementIds["MyPlansRecentPivot"] = "myPlansRecentPivot";
    ElementIds["MyPlansSharedPivot"] = "myPlansSharedPivot";
    ElementIds["MyPlansPersonalPivot"] = "myPlansPersonalPivot";
    ElementIds["MyPlansPinnedPivot"] = "myPlansPinnedPivot";
    ElementIds["MyPlansMyTeamsPivot"] = "myPlansMyTeamsPivot";
    ElementIds["MyPlansRecommendedPivot"] = "myPlansRecommendedPivot";
    ElementIds["MyPlansNewPlanButton"] = "myPlansNewPlanButton";
    /** My Portfolios element ids */ ElementIds["MyPortfoliosNewPortfolioButton"] = "myPortfoliosNewPortfolioButton";
    /** Plan view element ids */ ElementIds["BoardViewPivot"] = "boardViewPivot";
    ElementIds["ScheduleViewPivot"] = "scheduleViewPivot";
    ElementIds["ChartsViewPivot"] = "chartsViewPivot";
    ElementIds["GridViewPivot"] = "gridViewPivot";
    ElementIds["GoalsViewPivot"] = "goalsViewPivot";
    ElementIds["BasicPlanGoalsAttachSourcesButton"] = "basicPlanGoalsAttachSourcesButton";
    ElementIds["BasicPlanGoalsResourcesButton"] = "basicPlanGoalsResourcesButton";
    ElementIds["HomeViewPivot"] = "homeViewPivot";
    ElementIds["TimelineViewPivot"] = "timelineViewPivot";
    ElementIds["GridViewSecondColumn"] = "gridViewSecondColumn";
    ElementIds["HeaderJoinButtonTooltip"] = "joinButtonTooltip";
    ElementIds["HeaderShareButton"] = "headerShareButton";
    ElementIds["HeaderMoreOptionsButton"] = "headerMoreOptionsButton";
    ElementIds["TaskFiltersButton"] = "taskFiltersButton";
    ElementIds["DynamicFilterPillMoreOptions"] = "dynamicFilterPillMoreOptions";
    ElementIds["SmartFilterCreateButton"] = "smartFilterCreateButton";
    ElementIds["CopilotButton"] = "copilotButton";
    ElementIds["GsdGoalsSection"] = "gsdGoalsSection";
    ElementIds["GsdResourcesSection"] = "gsdResourcesSection";
    ElementIds["PremiumAddGoalButton"] = "premiumAddGoalButton";
    ElementIds["AddFilesButton"] = "addFilesButton";
    ElementIds["ViewOptionsButton"] = "viewOptionsCommand";
    ElementIds["StatusReportViewPivot"] = "statusReportViewPivot";
    ElementIds["StatusReportViewPivotEvo"] = "statusReportViewPivotEvo";
    ElementIds["PremiumGoalsViewPivot"] = "premiumGoalsViewPivot";
    ElementIds["PremiumPlanGroupByButton"] = "premiumPlanGroupByButton";
    ElementIds["PeopleViewPivot"] = "peopleViewPivot";
    /** Team View element ids */ ElementIds["TeamViewFirstUnscheduledTaskCard"] = "teamViewFirstUnscheduledTaskCard";
    /** Create Plan Element ids */ ElementIds["FromMicrosoftPivot"] = "fromMicrosoftPivot";
    ElementIds["SharedPivot"] = "sharedPivot";
    ElementIds["CreatedByMePivot"] = "createdByMePivot";
    /** Task details dialog element ids */ ElementIds["TaskDetailsMoreOptionsButton"] = "taskDetailsMoreOptionsButton";
    ElementIds["TaskDetailsStartDateCalendarIcon"] = "taskDetailsStartDateCalendarIcon";
    /** Share plan dialog */ ElementIds["SharePlanCreateGroupPivot"] = "sharePlanCreateGroupPivot";
    ElementIds["SharePlanExistingGroupPivot"] = "sharePlanExistingGroupPivot";
    ElementIds["SharePlanPeoplePivot"] = "sharePlanPeoplePivot";
    ElementIds["SharePlanAgentsPivot"] = "sharePlanAgentsPivot";
    ElementIds["SharePlanMeetingsPivot"] = "sharePlanMeetingsPivot";
    /** Plan settings panel */ ElementIds["PlanSettingsGeneralTab"] = "planSettingsGeneralTab";
    ElementIds["PlanSettingsTitle"] = "planSettingsTitle";
    ElementIds["PlanSettingsContent"] = "planSettingsContent";
    /** Copilot Dynamic Action Bar (DAB) button */ ElementIds["CopilotDab"] = "copilotDab";
    /** Floating Action Button (FAB) */ ElementIds["FABButton"] = "fabButton";
    /** The first task card in the "Ready for review" column of PMA board view */ ElementIds["PMACompletedTaskCard"] = "pmaCompletedTaskCard";
    /** The overflow (...) button in the project page command bar (rendered by AbstractTasksPage) */ ElementIds["CommandBarOverflowButton"] = "commandBarOverflowButton";
    return ElementIds;
}({});
/** Element ids for top-level view wrappers (eg. Basic or Premium plan view) */ export var ViewElementIds = /*#__PURE__*/ function(ViewElementIds) {
    ViewElementIds["PlanView"] = "planView";
    ViewElementIds["BasicPlanView"] = "basicPlanView";
    ViewElementIds["PremiumPlanView"] = "premiumPlanView";
    ViewElementIds["BasicTaskDetailsView"] = "basicTaskDetailsView";
    ViewElementIds["PremiumTaskDetailsView"] = "premiumTaskDetailsView";
    ViewElementIds["MyTasksView"] = "myTasksView";
    ViewElementIds["MyDayView"] = "myDayView";
    ViewElementIds["MyPlanView"] = "myPlanView";
    return ViewElementIds;
}({});
/**
 * Stable class names for the parts of `TaskPane`, so a host can align the pane's parts to its own
 * gutter. The pane's title, add-task button and card list each carry a different built-in inline
 * offset, which is invisible in Calendar view (the pane floats in a wide gap) but reads as ragged in
 * Team View, where the column butts straight against the chart. Hosts need a hook that is not the
 * pane's generated Griffel class or its test ids.
 */ export var TaskPaneElementClassNames = /*#__PURE__*/ function(TaskPaneElementClassNames) {
    TaskPaneElementClassNames["Title"] = "taskPaneTitle";
    TaskPaneElementClassNames["Scrollable"] = "taskPaneScrollable";
    return TaskPaneElementClassNames;
}({});
/** Class name constants for board view elements */ export var BoardViewElementClassNames = /*#__PURE__*/ function(BoardViewElementClassNames) {
    BoardViewElementClassNames["TaskBoardAddTaskToggleButton"] = "addButton";
    BoardViewElementClassNames["AddTaskCardAddTaskButton"] = "addTaskButton";
    return BoardViewElementClassNames;
}({});
/** The left nav collapse threshold in px */ export const LeftNavCollapseThreshold = 1024;
/** Breakpoint (px) below which the task editor panel falls back to a dialog overlay, so it no longer shares the right pane and can coexist with Copilot. */ export const TaskEditorPanelDialogFallbackBreakpoint = 1024;
/** The number of shimmer rows to show in the grid view when loading tasks */ export const DefaultNumberOfGridShimmerRows = 15;
/** The number of max characters to show before truncation in the bucket title related strings */ export const MaxBucketTitleCharacters = 18;
/** The maximum number of characters displayed for goal title in toasts */ export const MaxGoalTitleCharacters = 18;
/** The maximum number of characters displayed for custom field definition (custom column) title in toasts */ export const MaxCustomFieldDefinitionTitleCharacters = 26;
/** The maximum number of characters displayed for a custom field name in the bulk task update toast */ export const MaxBulkEditFieldNameCharactersForToast = 26;
/** The maximum number of characters displayed for title in toasts */ export const MaxTitleCharactersForToast = 26;
/** The maximum number of characters displayed for plan title in toasts when pinning */ export const MaxPlanTitleCharactersForPinning = 25;
/** The maximum number of characters displayed for plan title in toasts when unpinning */ export const MaxPlanTitleCharactersForUnpinning = 40;
/** Heights for Create Task From Teams Message Dialog */ export const CreateTaskFromMessageDialogHeights = {
    ToDoTasks: 375,
    BasicTasks: 425
};
/** Width for Create Task From Teams Message Dialog */ export const CreateTaskFromMessageDialogWidth = 800;
/** Picker offset (px) used by the task editor's assignment row so the popover aligns with the editor's vertical rhythm rather than the default 10px gap. */ export const TaskDetailsAssignmentPickerOffset = 22;
/** Minimum accepted value for a task's percent-complete field (domain rule: 0–100 integer). */ export const PercentCompleteMinValue = 0;
/** Maximum accepted value for a task's percent-complete field (domain rule: 0–100 integer). */ export const PercentCompleteMaxValue = 100;
/** Step size used by percent-complete inputs (spin button and grid editor arrow keys). */ export const PercentCompleteStepSize = 25;
